import axios from '../axios'

const getCode = data => {
  return axios({
    url: '/customer/recycle/order/sendEmailCode',
    method: 'post',
    data
  })
}

const verifyCode = data => {
  return axios({
    url: '/customer/recycle/order/verifyEmailCode',
    method: 'post',
    data
  })
}
const getCountries = params => {
  return axios({
    url: '/customer/recycle/order/getAllCountryCode',
    method: 'get',
    params
  })
}
const getPostCode = params => {
  return axios({
    url: '/customer/recycle/order/getPagePostCode',
    method: 'get',
    params
  })
}
const getCities = params => {
  return axios({
    url: '/customer/recycle/order/getPlaceNameByCountryCodeAndPostCode',
    method: 'get',
    params
  })
}
const successOrder = data => {
  return axios({
    url: '/customer/recycle/order/submit',
    method: 'post',
    data
  })
}

export {
  getCode,
  verifyCode,
  getCountries,
  getPostCode,
  getCities,
  successOrder
}
